import { Component, Input, OnInit } from '@angular/core';
import { VisitorTrackerFullDTO } from '../../../services/api/api';

@Component({
  selector: 'sb-comp-tracker-status',
  templateUrl: './tracker-status.component.html',
  styleUrls: ['./tracker-status.component.scss'],
  standalone: false,
})
export class TrackerStatusComponent implements OnInit {
  @Input() tracker: VisitorTrackerFullDTO;

  constructor() {}

  ngOnInit(): void {}
}
